module.exports = __webpack_public_path__ + "static/img/196a2fb0.svg";